import { Grid, Slide } from '@mui/material';
import { RoutalCrossIcon as CrossIcon, RoutalPalette } from '@nx-smartmonkey/ui';
import { createPortal } from 'react-dom';

interface SlidingMenuProps {
  id: string;
  isOpen: boolean;
  onClose: (...args: any[]) => any;
  headerContent?: React.ReactNode;
  footerContent?: React.ReactNode;
  direction?: `left` | `right` | `up` | `down`;
  background?: string;
  slideStyles?: React.CSSProperties;
  headerStyles?: React.CSSProperties;
  childrenStyles?: React.CSSProperties;
  timeout?: { enter?: number; exit?: number };
  hideCross?: boolean;
  portalElementId?: string;
}

export const SlidingMenu = ({
  id,
  isOpen,
  onClose,
  headerContent,
  footerContent,
  children,
  direction = `left`,
  background,
  slideStyles = {},
  headerStyles = {},
  childrenStyles = {},
  timeout = {},
  hideCross = false,
  portalElementId,
}: React.PropsWithChildren<SlidingMenuProps>) => {
  if (!isOpen) return null;

  const content = (
    <Slide
      key={id}
      in
      direction={direction}
      mountOnEnter
      unmountOnExit
      timeout={{ enter: 400, exit: 300, ...timeout }}
      style={{ zIndex: 1006, position: `absolute`, ...slideStyles }}
    >
      <Grid
        style={{
          height: `100%`,
          width: `100%`,
          overflowY: `hidden`,
          background,
        }}
      >
        <Grid
          container
          wrap="nowrap"
          direction="column"
          style={{
            height: `100%`,
          }}
        >
          <Grid
            container
            direction="row"
            wrap="nowrap"
            alignItems="center"
            style={{
              padding: `0 20px`,
              background,
              borderBottom: `1px solid ${RoutalPalette.neutral10}`,
              ...headerStyles,
            }}
          >
            {headerContent}
            {!hideCross && (
              <CrossIcon
                style={{
                  color: RoutalPalette.secondary40,
                  height: `20px`,
                  width: `20px`,
                  fontSize: `20px`,
                  cursor: `pointer`,
                }}
                onClick={() => onClose()}
              />
            )}
          </Grid>

          <Grid
            container
            direction="column"
            style={{
              padding: `20px`,
              flex: 1,
              background: background || undefined,
              overflowY: `auto`,
              ...childrenStyles,
            }}
          >
            {children}
          </Grid>
          {footerContent}
        </Grid>
      </Grid>
    </Slide>
  );

  const element = document.getElementById(portalElementId ?? ``);
  if (element) {
    return createPortal(content, element as HTMLElement);
  }

  return content;
};
